'use strict';
import React, { PureComponent } from 'react';


class IndicadoresInterfaz extends PureComponent {
    constructor(props) {
        super(props);

        this.buscarIndicadoresInterfaz = this.buscarIndicadoresInterfaz.bind(this);
    }

    buscarIndicadoresInterfaz(valorInput, descripcionIndicadorInterfaz, esIndicadorSeleccionado, idSeleccionado) {
        this.props.buscarIndicadoresInterfaz(valorInput, descripcionIndicadorInterfaz, esIndicadorSeleccionado, idSeleccionado);
    }

    render() {
        const { indicador } = this.props;

        let descripcionIndicadorInterfaz = indicador.Codigo + " - " + indicador.Descripcion

        return (
            <div className="ABMModelos__opcionBuscadorCuentasContables ABMModelos__opcionBuscadorImportarModelos" onClick={() => this.buscarIndicadoresInterfaz("", descripcionIndicadorInterfaz, true, indicador.Id)}>
                {descripcionIndicadorInterfaz}
            </div>
        );
    }
}

export default IndicadoresInterfaz;